/**
 * Both queries take `$now` (see `blog_query_now`) and leave out posts dated in the future, so a post
 * published in Sanity ahead of time goes live on its `publishedAt`, on the index and by URL.
 */
export const BLOG_POSTS_LIST_GROQ = `*[_type == "post" && defined(slug.current) && hidden != true && dateTime(publishedAt) <= dateTime($now)] | order(publishedAt desc) {
  _id,
  title,
  "slug": slug.current,
  publishedAt,
  author,
  excerpt,
  mainImage {
    ...,
    "dimensions": asset->metadata.dimensions
  },
  seo
}`

export const BLOG_POST_BY_SLUG_GROQ = `*[_type == "post" && slug.current == $slug && dateTime(publishedAt) <= dateTime($now)][0] {
  _id,
  title,
  "slug": slug.current,
  publishedAt,
  author,
  excerpt,
  mainImage {
    ...,
    "dimensions": asset->metadata.dimensions
  },
  body,
  seo
}`

/**
 * The `$now` both queries compare `publishedAt` against: the current time rounded down to the hour.
 * Sent from the caller (not GROQ's `now()`) so the CDN caches one response per hour, not a
 * `now()` result that would stay cached past a post's date.
 */
export function blog_query_now(date: Date = new Date()): string {
  const hour = new Date(date)
  hour.setUTCMinutes(0, 0, 0)
  return hour.toISOString()
}
